export default __webpack_public_path__ + "static/media/coding-bootcamp-full-stack-developer-certificate.b25fc874.jpg";